<script setup lang="ts">
import { ref, onMounted, onBeforeUnmount } from 'vue'

withDefaults(defineProps<{ label?: string; align?: 'left' | 'right' }>(), {
  align: 'left',
})

const open = ref(false)
const root = ref<HTMLElement | null>(null)

function close() {
  open.value = false
}

function onDocPointer(e: PointerEvent) {
  if (root.value && !root.value.contains(e.target as Node)) close()
}

onMounted(() => document.addEventListener('pointerdown', onDocPointer))
onBeforeUnmount(() => document.removeEventListener('pointerdown', onDocPointer))
</script>

<template>
  <div ref="root" class="relative">
    <button
      type="button"
      @click="open = !open"
      :aria-expanded="open"
      aria-haspopup="menu"
      class="flex items-center gap-1 text-sm text-gray-600 hover:text-teal-600">
      <slot name="trigger">{{ label }}</slot>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"
        class="w-3.5 h-3.5 transition-transform" :class="{ 'rotate-180': open }" aria-hidden="true">
        <path fill-rule="evenodd" d="M5.23 7.21a.75.75 0 0 1 1.06.02L10 11.168l3.71-3.938a.75.75 0 1 1 1.08 1.04l-4.25 4.5a.75.75 0 0 1-1.08 0l-4.25-4.5a.75.75 0 0 1 .02-1.06z" clip-rule="evenodd"/>
      </svg>
    </button>
    <!-- Clicking any item bubbles up here and closes the menu. -->
    <div
      v-if="open"
      @click="close"
      :class="align === 'right' ? 'right-0' : 'left-0'"
      class="absolute z-50 mt-2 min-w-[11rem] rounded-md border border-gray-200 bg-white py-1 shadow-lg">
      <slot />
    </div>
  </div>
</template>
